/**
 * The extension name for the Prisma fractional indexing extension.
 */
export const EXTENSION_NAME = "fraci";
